import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { ExternalLink } from "components/common";
const GreyNoiseAdapterDocumentation = () => {
  const { t } = useTranslation("integrations");
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", { style: { marginBottom: 10 } }, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "grey_noise_adapter_documentation.description",
      components: {
        greynoiseLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://developer.greynoise.io/" }),
        quickContextLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://developer.greynoise.io/reference/ip-lookup-1#quickcheck-1" })
      }
    }
  )));
};
export default GreyNoiseAdapterDocumentation;
